import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Category } from '../domain/Category';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-product-category',
  templateUrl: './product-category.component.html',
  host: { "(window:keyup)": "hotkeys($event)", "(window:click)": "hotClick($event)" },
  styleUrls: ['./product-category.component.css']
})
export class ProductCategoryComponent implements OnInit {
  @ViewChild("categoryName", { static: false }) categoryNameInput: ElementRef;
  categoryId: string;
  mode: string;
  category: Category;
  loading: boolean = false;
  isConfirmationBox: boolean = false;
  user: IUser;
  enterSteps: any[];
  currentStep: any;

  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private route: ActivatedRoute,
    private appServiceManager: AppServiceManager,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router
  ) {
    route.params.subscribe((params) => {
      this.categoryId = params["id"];
      if (this.categoryId !== null && this.categoryId !== undefined) {
        this.getProductCategoryById(this.categoryId);
        this.mode = 'edit';
        this.breadcrumbService.setItems([
          { label: "Categories", routerLink: ["/product-categories"] },
          { label: "Edit-Category" },
        ]);
      } else {
        this.mode = 'add';
        this.breadcrumbService.setItems([
          { label: "Categories", routerLink: ["/product-categories"] },
          { label: "Add-Category" },
        ]);
      }
    });
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("ProductCategoryComponent", label);
  }
  ngOnInit() {
    this.category = new Category();
    this.user = AuthService.getLoggedInUser();
    this.currentStep = 0;

    if (this.mode == 'edit') {
      this.enterSteps = [
        "categoryName",
        "categoryDescription",
        "updateCategory",
      ];
    } else if (this.mode == 'add') {
      this.enterSteps = [
        "categoryName",
        "categoryDescription",
        "saveCategory",
      ];
    }
  }

  ngAfterViewInit() {
    this.categoryNameInput.nativeElement.focus();
  }

  getProductCategoryById(categoryId) {
    this.loading = true;
    this.appServiceManager.get("products/category/" + categoryId).subscribe(
      (data: any) => {
        if (data) {
          this.category = data;
          this.loading = false;
        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      error => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });

      }
    );
  }

  save() {
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to save ?",
      accept: () => {
        this.isConfirmationBox = false;
        this.category.company = this.user.company;
        this.category.branch = this.user.branch;
        this.appServiceManager.post("products/category", this.category).subscribe((res: any) => {
          if (res) {
            this.category = res.category;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Product Category Added' });
            this.router.navigateByUrl('product-category/' + this.category._id)

          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        this.isConfirmationBox = false;
      }
    });
  }

  update() {
    this.isConfirmationBox = true;
    this.confirmationService.confirm({
      message: "Are you sure you want to update ?",
      accept: () => {
        this.isConfirmationBox = false;
        this.category.company = this.user.company;
        this.category.branch = this.user.branch;
        // this.visitor.modifiedBy = this.user._id;
        this.appServiceManager.put("products/category/" + this.category._id, this.category).subscribe((res: any) => {
          if (res) {
            this.category = res.category;
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Product Category Updated' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
        },
          (error) => {
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      },
      reject: () => {
        this.isConfirmationBox = false;
      }
    });
  }

  hotkeys($event) {
    if ($event.keyCode == 39 || $event.keyCode == 37) {
      var confirmationBox = document.getElementsByTagName("p-confirmdialog")[0];
      var confirmationBoxButtonExist = confirmationBox.getElementsByTagName("button");
      var confirmationBoxButtonExistLength = confirmationBox.getElementsByTagName("button").length;
      if (confirmationBoxButtonExistLength > 0) {
        if (document.activeElement.tagName === "BODY") {
          confirmationBoxButtonExist[0].focus();
        }
        else {
          if (document.activeElement === confirmationBoxButtonExist[0]) {
            confirmationBoxButtonExist[1].focus();
          }
          else if (document.activeElement === confirmationBoxButtonExist[1]) {
            confirmationBoxButtonExist[0].focus();
          }
          else {
            confirmationBoxButtonExist[0].focus();
          }
        }
      }
    }
    else if ($event.keyCode == 13 && !this.isConfirmationBox) {
      var nextStep = this.enterSteps.length - 1 > this.currentStep ? this.currentStep + 1 : 0;
      var nextId = this.enterSteps[nextStep];
      let ele: any = document.getElementById(nextId)
      if (ele.disabled && nextId == "saveCategory") {
        document.getElementById("categoryName").focus();
        this.currentStep = 0;

      } else if (ele.disabled && nextId == "updateCategory") {
        document.getElementById("categoryName").focus();
        this.currentStep = 0;

      } else {
        ele.focus();
        this.currentStep = nextStep;
      }
    } else if ($event.keyCode == 113) {
      this.router.navigateByUrl("product-category");

    }

  }

  hotClick($event) {
    let currentClickLocation = $event.target.id;
    let indexOfClickField = this.enterSteps.indexOf(currentClickLocation);
    if (indexOfClickField !== -1) {
      this.currentStep = indexOfClickField;
    } else {
      this.currentStep = this.currentStep;
    }
  }
}
